import type { ModuleFile } from '../../core/modules.ts';

// Módulo «presentation»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'presentation',
    title: 'Presentación',
    projectTab: { segment: 'presentacion', label: 'Presentación', order: 6 },
    load: () => import('./PresentationPage.tsx').then((m) => ({ default: m.PresentationPage })),
  },
];
